// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2-4i7","primary":"Button_primary__1lk2L","info":"Button_info__7QE47","outline":"Button_outline__2DnPc"};